export enum Country {
    NLD,
    DE,
    UK
}

export namespace Country {

    export function values() {
        return Object.keys(Country).filter(
            (type) => isNaN(<any>type) && type !== 'values'
        );
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/company/models/country.ts